import type { CityConfig } from "../city-template/types";

export const portHuronConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — St. Clair County Clerk", href: "https://www.stclaircounty.org/clerk", description: "St. Clair County Clerk — marriage license issuance" },
    { label: "Divorce Records — St. Clair County Clerk", href: "https://www.stclaircounty.org/clerk", description: "St. Clair County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Port Huron",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "port-huron",
  route: "/cities/port-huron",
  title: "Emergency Passport Port Huron, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Port Huron, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Port Huron, Marysville, Fort Gratiot, Marine City, and all St. Clair County residents. Blue Water Bridge and Canada border travel expertise. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Port Huron, MI",
  heroSubtitle: "Port Huron travelers — Blue Water Bridge crossers, Sarnia commuters, lakefront boaters, and international families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of St. Clair County and the eastern Michigan border.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Port%20Huron%20Michigan%20waterfront%20with%20the%20Blue%20Water%20Bridge%20spanning%20across%20the%20St.%20Clair%20River%20toward%20Sarnia%20Canada%2C%20Fort%20Gratiot%20lighthouse%20on%20the%20shoreline%2C%20modern%20waterfront%20buildings%20along%20the%20riverfront%2C%20warm%20golden%20hour%20light%2C%20clear%20sky%20with%20soft%20clouds%2C%20rich%20blue%20water%2C%20no%20text%20no%20people%2C%20cinematic%20landscape%20photography&width=1800&height=700&seq=port-huron-hero-001&orientation=landscape",
  heroImageAlt: "Port Huron Michigan waterfront with Blue Water Bridge and Fort Gratiot lighthouse at golden hour",
  geoPosition: "42.9709;-82.4249",
  geoPlacename: "Port Huron, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 60 miles south of Port Huron — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Port Huron", zips: "48060, 48061, 48062" },
    { name: "Marysville", zips: "48040" },
    { name: "Fort Gratiot", zips: "48059" },
    { name: "Marine City", zips: "48039" },
    { name: "St. Clair", zips: "48079" },
    { name: "Richmond", zips: "48062" },
    { name: "New Baltimore", zips: "48047" },
    { name: "Algonac", zips: "48001" },
    { name: "Yale", zips: "48097" },
    { name: "Capac", zips: "48014" },
    { name: "Lexington", zips: "48450" },
    { name: "Memphis", zips: "48041" },
    { name: "Clyde", zips: "48049" },
    { name: "Emmett", zips: "48022" },
    { name: "Goodells", zips: "48027" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "Blue Water Bridge Expertise", desc: "Canada border crossing and Sarnia commuter passport requirements" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from anywhere in St. Clair County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Saint Clair Shores, MI", route: "/cities/saint-clair-shores" },
    { name: "Emergency passport services in Detroit, MI", route: "/cities/detroit" },
    { name: "Urgent passport services in Sterling Heights, MI", route: "/cities/sterling-heights" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Port Huron, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the 60-mile drive or appointment wait. Port Huron residents can ship from any UPS or FedEx in St. Clair County.",
  fpcOfficeDistance: "Serving Port Huron, Marysville, Fort Gratiot, Marine City, St. Clair, Richmond, New Baltimore, Algonac, and all of St. Clair County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Port Huron and the greater St. Clair County area. From the Blue Water Bridge waterfront to the Fort Gratiot lighthouse, from Marysville to Marine City, from Algonac to New Baltimore — we serve all of the eastern Michigan border region. The Detroit Passport Agency is approximately 60 miles south, and our couriers have direct access to it.",
  nearbyCitiesIntro: "We serve Port Huron and all St. Clair County communities including Marysville, Fort Gratiot, Marine City, St. Clair, Richmond, New Baltimore, Algonac, Yale, Capac, and surrounding areas. We also serve Blue Water Bridge travelers and Sarnia commuters.",
  howItWorksIntro: "Most Port Huron travelers complete everything online and ship documents overnight. No driving 60 miles to the Detroit Passport Agency or waiting weeks for an appointment — our registered couriers handle the submission for you.",
  mistakesIntro: "Port Huron is a unique border city with heavy Canada cross-border traffic and boating community travel needs. Here are the most common passport mistakes we see from St. Clair County travelers.",
  testimonialsIntro: "Port Huron travelers — from Blue Water Bridge commuters to lakefront boaters to international families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Port Huron, MI? Here are the most common ones we hear from St. Clair County and Blue Water Bridge travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for Canada border and lake travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person in Detroit — 60-mile drive", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Port Huron travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute Blue Water Bridge crossings, family emergencies, and lake travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Canada border and international travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Port Huron adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your St. Clair County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Port Huron residents and families — including international students, new citizens, and St. Clair County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Port Huron residents who lost their passport before international travel or Canada border crossing.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Port Huron-area families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Port Huron and St. Clair County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Port Huron MI", description: "Urgent passport processing for Port Huron Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Port Huron MI", description: "Fast passport renewal for Port Huron Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Port Huron MI", description: "New passport application services for Port Huron Michigan residents applying for their first passport." },
    { name: "Child Passport Port Huron MI", description: "Minor passport services for Port Huron Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Port Huron, MI",
      rating: 5,
      text: "My husband and I had a cruise out of Montreal in 5 days and both our passports were expired. Fast Passport Center saved our trip — renewed passports in 3 days. We shipped from the Port Huron UPS store and everything went perfectly.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Robert K.",
      location: "Marysville, MI",
      rating: 5,
      text: "I commute to Sarnia for work and my passport was stolen. Fast Passport Center had a replacement in my hands in 48 hours. I didn't miss a single day at work. Their courier service is a game changer for Blue Water Bridge travelers.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Angela T.",
      location: "Fort Gratiot, MI",
      rating: 5,
      text: "Family trip to the Bahamas with 7 days notice. Three passports for my kids and a renewal for me. Fast Passport Center handled everything. The document review caught an error on one of the forms that would have delayed us.",
      service: "Family Passport Bundle",
    },
    {
      name: "David L.",
      location: "Marine City, MI",
      rating: 5,
      text: "Boating trip to Canada and realized my passport expired two months ago. Fast Passport Center got me a renewed passport in 4 days. The whole process was seamless — I shipped from my marina office.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "porthuron-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 60 miles south of Port Huron — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "porthuron-2",
      name: "Port Huron Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1425 24th St",
      city: "Port Huron",
      state: "MI",
      zip: "48060",
      phone: "(810) 987-1400",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Port Huron — convenient to the waterfront and Blue Water Bridge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Port Huron acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Port Huron, waterfront, and Blue Water Bridge area residents.",
      icon: "ri-mail-line",
    },
    {
      id: "porthuron-3",
      name: "Marysville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1150 Delaware Ave",
      city: "Marysville",
      state: "MI",
      zip: "48040",
      phone: "(810) 364-2120",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Marysville — approximately 5 miles south of Port Huron",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Marysville and southern Port Huron residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "porthuron-4",
      name: "Fort Gratiot Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3210 Pine Grove Ave",
      city: "Fort Gratiot",
      state: "MI",
      zip: "48059",
      phone: "(810) 385-3690",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fort Gratiot — approximately 5 miles north of Port Huron",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Port Huron, Fort Gratiot, and communities north of the city. Book early during summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "porthuron-5",
      name: "St. Clair Shores Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "23031 Greater Mack Ave",
      city: "St. Clair Shores",
      state: "MI",
      zip: "48080",
      phone: "(586) 773-2660",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "St. Clair Shores — approximately 45 miles south of Port Huron",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southern St. Clair County and Macomb County residents. A larger facility with more appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in St. Clair County" },
    { feature: "Canada Border Expertise", agency: "No tailored advice", fpc: "Yes — Blue Water Bridge, Sarnia, and lake travel" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Port Huron boaters and Canada commuters often discover passport issues right before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for Air Travel to Canada",
      description: "Many Port Huron-area residents crossing the Blue Water Bridge use a passport card or enhanced license — but these are not valid for air travel. If you fly to Canada, you need a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at St. Clair County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Canada Entry Requirements",
      description: "Canada has its own entry requirements separate from passport validity. Blue Water Bridge and Sarnia travelers should verify current Canadian customs and immigration rules before crossing.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in St. Clair County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Port Huron, Marysville, or Fort Gratiot." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no 60-mile drive or appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your St. Clair County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport agency to Port Huron, MI?", a: "The Detroit Passport Agency is the nearest regional passport agency to Port Huron, located at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 60 miles south. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can submit applications without individual appointments, saving you the long drive." },
    { q: "How fast can I get an emergency passport in Port Huron?", a: "Fast Passport Center offers emergency passport processing in Port Huron, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to drive 60 miles south or take a day off work." },
    { q: "Do I need a passport to cross the Blue Water Bridge to Canada?", a: "For air travel to Canada, yes — you need a passport book. For land crossings via the Blue Water Bridge to Sarnia, Ontario, U.S. citizens can use a passport book, passport card, enhanced driver's license, or Trusted Traveler card (NEXUS, SENTRI, Global Entry). A passport book provides the most flexibility for all types of travel. NEXUS is especially popular for frequent Blue Water Bridge commuters." },
    { q: "Can I get an expedited passport in the Port Huron suburbs like Marysville or Fort Gratiot?", a: "Absolutely. Fast Passport Center serves all of St. Clair County including Marysville, Fort Gratiot, Marine City, St. Clair, Richmond, New Baltimore, Algonac, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Port Huron-area travelers use for international flights?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub for Port Huron and St. Clair County travelers — approximately 65 miles south. DTW offers direct flights to London, Amsterdam, Tokyo, Mexico City, Cancun, and dozens of other international destinations. The St. Clair County International Airport (PHN) is a smaller regional airport with limited commercial service. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Port Huron, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Port Huron-area residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations in Port Huron, Marysville, and Fort Gratiot offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the Upper Peninsula from Port Huron?", a: "Yes. Fast Passport Center serves all of Michigan including the Upper Peninsula. Our courier service is especially valuable for remote UP communities, which would otherwise face an 8+ hour drive to the Detroit Passport Agency. We serve Marquette, Sault Ste. Marie, Houghton, Escanaba, and all UP communities — you just ship your documents overnight and we handle everything from there." },
  ],
  photoLocations: [
    { name: "Walgreens — Pine Grove Ave", address: "3200 Pine Grove Ave, Port Huron, MI 48060", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Port Huron", address: "1200 24th St, Port Huron, MI 48060", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Port Huron", address: "3700 Pine Grove Ave, Port Huron, MI 48060", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Marysville", address: "1005 Allen Rd, Marysville, MI 48040", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Port Huron", address: "4200 24th Ave, Fort Gratiot, MI 48059", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves Port Huron, Fort Gratiot, and northern St. Clair County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Marysville", address: "1150 Delaware Ave, Marysville, MI 48040", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Marysville and southern Port Huron communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "Approximately 65 miles south of Port Huron via I-94",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for St. Clair County. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "PHN",
      name: "St. Clair County International Airport",
      distance: "Located in Port Huron — regional/charter flights",
      address: "Reid St, Port Huron, MI 48060",
      note: "Smaller regional airport primarily for charter, private flights, and limited commercial service. Not used for major international travel. DTW remains the main gateway for international departures.",
      flightUrl: "https://www.stclaircounty.org/offices/airport/",
      flightLabel: "St. Clair County Airport Info",
      featured: false,
    },
  ],
};